import { IconButton, Typography } from "@mui/material";

import Svg, { SvgEnum } from "../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../ui library/HNSColors";

export default function Chip({ chip, handleDelete }) {
  return (
    <div
      className="flex w-fit max-w-40 flex-row items-center justify-between rounded-[400px] px-2 py-1"
      style={{ backgroundColor: HNSColors.secondary[900] }}
    >
      <div className="px-2">
        <Typography className="text-[14px]" style={{ color: HNSColors.secondary[400] }}>
          {chip.label}
        </Typography>
      </div>
      <div className="px-2">
        <IconButton onClick={() => handleDelete(chip)} size="small">
          <Svg name={SvgEnum.HisX} color={HNSColors.secondary[400]} sx={{ width: 24, height: 24 }} />
        </IconButton>
      </div>
    </div>
  );
}
